import InputField from "../../../components/InputField";
import SelectField from "../../../components/SelectField";
import Toggle from "../../../components/Toggle";

export default function DurataClauzeStep({ data, errors, update }) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
      <div style={{ width: "100%" }}>
        <Toggle
          label="Durata nedeterminata"
          description="Contractul nu are o data de sfarsit stabilita"
          checked={!!data.durataNedeterminata}
          onChange={() => update("durataNedeterminata")(!data.durataNedeterminata)}
        />
      </div>

      {!data.durataNedeterminata ? (
        <>
          <InputField label="Data inceput" value={data.dataInceput} onChange={update("dataInceput")} type="date" required half error={errors.dataInceput} />
          <InputField label="Data sfarsit" value={data.dataSfarsit} onChange={update("dataSfarsit")} type="date" required half error={errors.dataSfarsit} />
        </>
      ) : (
        <InputField label="Data inceput" value={data.dataInceput} onChange={update("dataInceput")} type="date" required half error={errors.dataInceput} />
      )}

      <SelectField
        label="Preaviz reziliere"
        value={data.preavizReziliere}
        onChange={update("preavizReziliere")}
        options={[
          { value: "15", label: "15 zile" },
          { value: "30", label: "30 zile" },
          { value: "60", label: "60 zile" },
        ]}
        half
      />

      <div style={{ width: "100%" }}>
        <Toggle
          label="Clauza de confidentialitate (NDA)"
          description="Partile se obliga sa pastreze confidentialitatea informatiilor"
          checked={!!data.includeNDA}
          onChange={() => update("includeNDA")(!data.includeNDA)}
        />
      </div>

      <div style={{ width: "100%" }}>
        <Toggle
          label="Clauza de non-concurenta"
          description="Prestatorul se obliga sa nu presteze servicii similare pentru concurentii beneficiarului"
          checked={!!data.includeNonCompete}
          onChange={() => update("includeNonCompete")(!data.includeNonCompete)}
        />
      </div>

      {data.includeNonCompete && (
        <>
          <SelectField
            label="Durata non-concurenta"
            value={data.nonCompeteDurata}
            onChange={update("nonCompeteDurata")}
            options={[
              { value: "6 luni", label: "6 luni" },
              { value: "1 an", label: "1 an" },
              { value: "2 ani", label: "2 ani" },
            ]}
            half
          />
          <InputField label="Domeniu non-concurenta" value={data.nonCompeteDomeniu} onChange={update("nonCompeteDomeniu")} placeholder="ex: dezvoltare software in Romania" half />
        </>
      )}

      <div style={{ width: "100%" }}>
        <Toggle
          label="Proprietatea intelectuala se transfera Beneficiarului"
          description="Daca nu este activat, drepturile raman la PFA"
          checked={!!data.transferPI}
          onChange={() => update("transferPI")(!data.transferPI)}
        />
      </div>
    </div>
  );
}
